export class PctHttpErrorResponse extends Error {
  override message: string;
  readonly status: number;
  readonly response: any;
  readonly headers: {
    [key: string]: any;
  };
  readonly originalError?: Error;

  constructor(
    message: string,
    status: number,
    response: any,
    headers: {
      [key: string]: any;
    },
    originalError?: Error,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.originalError = originalError;
  }
}
